import React, { useState, useEffect } from "react";
import styled from "styled-components";
import HLine from "../../components/components/hline";
import { Heading } from "../../components/components/text";
import "./style.css";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { login, reset } from "../../../features/auth/authSlice";

const LoginForm = styled.div`
  margin-top: 10px;
`;

const LostContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    margin-bottom: 0.3rem;
  }
  .create-new-acc {
    font-size: 1.2rem;
  }
  a {
    text-decoration: none;
    font-weight: bold;
  }
`;

export default function Login() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isLoading, isError, isSuccess, message } = useSelector(
    // @ts-ignore
    (state) => state.auth
  );

  useEffect(() => {
    if (isError) {
      toast.error(message);
    }
    // if (isSuccess || user) {
    //   navigate("/");
    // }
    dispatch(reset());
  }, [user, isError, isSuccess, message, navigate, dispatch]);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (password.length == 0 || email.length == 0) {
      toast.error("Please type in your credentials to log in.");
    } else {
      const userData = {
        email,
        password,
      };
      dispatch(login(userData));
    }
  };

  return (
    <>
      <HLine />
      <Heading>Login:</Heading>
      <HLine />
      <LoginForm>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <div>Login:</div>
            <input
              type="text"
              name="email"
              className="form-control"
              id="email"
              value={email}
              placeholder="Enter your login"
              onChange={onChange}
            />
          </div>

          <div className="form-group">
            <div>Password:</div>

            <input
              type="password"
              name="password"
              className="form-control"
              id="password"
              value={password}
              placeholder="Enter your password"
              onChange={onChange}
            />
          </div>

          <div className="form-group">
            <button type="submit" className="btn btn-block">
              Login
            </button>
          </div>
        </form>
      </LoginForm>
      <LostContainer>
        <div>
          <Link to="/register" className="create-new-acc">
            Create new account
          </Link>
        </div>
        <div>
          <span>
            Lost <a href="#">username</a> or <a href="#">password</a>?
          </span>
        </div>
      </LostContainer>
    </>
  );
}
